// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1jbh9","label":"Completed_label__Fu7xc"};